import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AppContext } from '../control/context';

@Component({
  selector: 'i-printable',
  templateUrl: './printable.component.html',
  styleUrls: ['./printable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintableComponent implements OnInit {
  @Input() text: string;
  @Input() setting: string;
  @Input() value: string;

  constructor(private appContext: AppContext, private changeDetection: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.setting) {
      this.value = '⧗';
      this.appContext.getSettingText$(this.setting).subscribe({
        next: (value) => {
          this.value = value;
          this.changeDetection.detectChanges();
        },
      });
    }
    if (this.text) {
      this.value = this.text;
    }
  }
}
